import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Button} from 'react-bootstrap';
import {confirmable, createConfirmation} from 'react-confirm';
import { BsQuestionLg, BsExclamationLg } from "react-icons/bs";
import checkW from '../images/checkW.svg';

const Confirmation = ({show, proceed, dismiss, cancel, confirmation, title,
  okText, cancelText, okButtonStyle, cancelButtonStyle, ...options}) => {
  const header = title ? (
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
  ) : undefined;
  return (
    <Modal
      className="centerModal"
      size="small"
      show={show}
      onHide={() => proceed(false)}
      backdrop="static"
      centered
    >
      {header}
      <div className="modalBody">
        <div className="modalIcon"><BsQuestionLg /></div>
        <p className="txtC">{confirmation}</p>
      </div>
      <div className="modalBtnWr">
        <button type="button" className="cancleBtn"
          onClick={() => proceed(false)}
        >
          {cancelText}
        </button>
        <button type="button"
          onClick={() => proceed(true)}
        >
          {okText}
        </button>
      </div>
    </Modal>
  );
};

Confirmation.propTypes = {
  /** header title */
  title: PropTypes.string,
  confirmation: PropTypes.string, // arguments of your confirm function
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  okButtonStyle: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger',
    'warning', 'info', 'light', 'dark', 'link']),
  cancelButtonStyle: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger',
    'warning', 'info', 'light', 'dark', 'link']),
  show: PropTypes.bool, // from confirmable.
  proceed: PropTypes.func, // from confirmable.
  cancel: PropTypes.func, // from confirmable.
  dismiss: PropTypes.func, // from confirmable.
};

Confirmation.defaultProps = {
  title: undefined,
  confirmation: undefined,
  okText: 'OK',
  cancelText: 'Cancel',
  okButtonStyle: 'primary',
  cancelButtonStyle: 'secondary',
  show: undefined,
  proceed: undefined,
  cancel: undefined,
  dismiss: undefined,
};

const confirmLow = createConfirmation(confirmable(Confirmation));

export const confirm = (message, options = {}) => {
  return confirmLow(Object.assign({confirmation: message}, options));
};


const Alert = ({show, proceed, dismiss, cancel, confirmation, title,
  okText, okButtonStyle, ...options}) => {
  const header = title ? (
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
  ) : undefined;
  return (
    <Modal
      className="centerModal"
      size="small"
      show={show}
      onHide={() => proceed()}
      keyboard={true}
      backdrop="static"
      centered
    >
      {header}
      <div className="modalBody">
        {
          okButtonStyle === 'primary' ? (<div className="modalIcon"><BsExclamationLg /></div>):(<div className="modalIconCheck"><img src={checkW} alt="체크"/></div>)
        }
        <p>{confirmation}</p>
      </div>
      <div className="modalBtnWr">
        <button type="button"
          onClick={() => proceed()}
        >
          {okText}
        </button>
      </div>
    </Modal>
  );
};

Alert.propTypes = {
  /** header title */
  title: PropTypes.string,
  confirmation: PropTypes.string, // arguments of your confirm function
  okText: PropTypes.string,
  okButtonStyle: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger',
    'warning', 'info', 'light', 'dark', 'link']),
  show: PropTypes.bool, // from confirmable.
  proceed: PropTypes.func, // from confirmable.
  cancel: PropTypes.func, // from confirmable.
  dismiss: PropTypes.func, // from confirmable.
};

Alert.defaultProps = {
  title: undefined,
  confirmation: undefined,
  okText: 'OK',
  okButtonStyle: 'primary',
  show: undefined,
  proceed: undefined,
  cancel: undefined,
  dismiss: undefined,
};

const alertLow = createConfirmation(confirmable(Alert));

export const alert = (message, options = {}) => {
  return alertLow(Object.assign({confirmation: message}, options));
};
